import React from 'react';
import { classNames } from './classNames';

export interface FileInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {}

const FileInput = React.forwardRef<HTMLInputElement, FileInputProps>(({
  className,
  accept = 'image/*',
  ...props
}, ref) => (
  <input
    ref={ref}
    type="file"
    accept={accept}
    className={classNames('form-control', className)}
    {...props}
  />
));

FileInput.displayName = 'FileInput';

export default FileInput;

